import React from 'react';
import { Navigate } from 'react-router-dom';

// Lazy load components
const Login = React.lazy(() => import('../pages/Login/Login'));
const LoginApplication = React.lazy(() => import('../pages/Login/LoginApplication'));
const SignUpPortalUser = React.lazy(() => import('../pages/Login/SignUpPortalUser'));
const SupportLogin = React.lazy(() => import('../pages/Login/SupportLogin'));

export const getAuthRoutes = (isDonorOrg) => [
  {
    path: '/login',
    element: isDonorOrg ? <Navigate to="/donors/login" replace /> : <Login />
  },
  {
    path: '/login-app',
    element: <LoginApplication />
  },
  {
    path: '/portal-user-signup',
    element: <SignUpPortalUser />
  },
  {
    path: '/support-login',
    element: <SupportLogin />
  },
  {
    // Old support-user admin link; adding support users now lives on the Users screen.
    path: '/support-ops-users',
    element: <Navigate to="/support/users" replace />
  }
];

